import axios from 'axios';
import qs from 'qs';
import client from './client';

//회사정보 가져오기
export const getCompanies = () => axios.get('/api/v1/user/company');

// //로그인
// export const login = (dataToSubmit) =>
//   axios.post('/api/v1/user/login', dataToSubmit);
export const login = (dataToSubmit) =>
  axios.post('/api/v1/user/login', dataToSubmit, {
    headers: { companyCd: dataToSubmit?.company },
  });

//유저정보
export const getUser = (data) =>
  axios.get('/api/v1/user/info', {
    headers: {
      Authorization: `Bearer ${data.token}`,
      companyCd: `${data?.companyCd}`,
    },
  });

//공통코드 가져오기
export const getBaseCode = (filterObject) => {
  const queryString = qs.stringify(filterObject);
  return client.get(`/api/v1/common/list?${queryString}`);
};

export const check = () =>
  axios.get('/api/v1/user/info', {
    headers: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem('access_token'),
      )}`,
    },
  });

//유저 정보 수정
export const editUserInfo = (dataToSubmit) => {
  return client.put(`/api/v1/user/info`, dataToSubmit);
};

//비밀번호 수정
export const changePwd = (dataToSubmit) => {
  return client.put(`/api/v1/user/changePwd`, dataToSubmit);
};

//결재 리스트 가져오기
export const getApprovals = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`/api/v1/common/approval/now?${queryString}`);
};

//내 캘린더 내역
export const getSchedules = (searchData) => {
  return client.get(`/api/v1/schedule/list`);
};

//노티 정보 가져오기
export const getNoties = () => {
  return client.get(`/api/v1/noti/list`);
};

//노티 정보 전체 확인 
export const confirmNotiAll = () => {
  return client.put(`/api/v1/noti/lists`);
};

//노티 확인
export const confirmNoties = (checkedNoties) => {
  // const queryString = qs.stringify(checkedNoties);
  //return client.put(`/api/v1/noti/info?${queryString}`);
  return client.put(`/api/v1/noti/info?arr=${checkedNoties}`);
};

//프로젝트 카운트 정보 가져오기(top menu)
export const getProjectCounts = () => {
  return client.get(`/api/v1/project/campaign/status/cnt`);
};
